export const ROUTE_CHANGE = '@@route/ROUTE_CHANGE';

export function updateRouteConfig(obj) {
  return {
    type: ROUTE_CHANGE,
    data: obj
  };
}
